import { api } from './client.js'

// Phase-2 Batch C1 — every result type except SearchRecording carries an
// optional `snippet` field with ts_headline output (matched tokens wrapped
// in `<b>...</b>`). Server-generated; the UI sanitises it on render
// (whitelist `<b>` / `</b>` only) before injecting via
// dangerouslySetInnerHTML.
export interface SearchConversation {
  id: string
  referenceId: string
  subject: string | null
  channelOrigin: string
  rank: number
  snippet?: string
}

export interface SearchContact {
  id: string
  name: string
  phoneE164: string
  email: string | null
  rank: number
  snippet?: string
}

export interface SearchCall {
  id: string
  uniqueId: string
  fromNumber: string
  toNumber: string
  startTime: string
  rank: number
  snippet?: string
}

// Recordings has no direct text source for ts_headline; intentionally
// omits the snippet field.
export interface SearchRecording {
  id: string
  callId: string
  durationSec: number
  createdAt: string
  rank: number
}

export interface SearchAgent {
  id: string
  extension: string
  userFullName: string | null
  rank: number
  snippet?: string
}

export interface SearchMessage {
  id: string
  conversationId: string
  contentPreview: string
  direction: 'inbound' | 'outbound' | string
  sentAt: string
  rank: number
  snippet?: string
}

export interface SearchResults {
  conversations: SearchConversation[]
  contacts: SearchContact[]
  calls: SearchCall[]
  recordings: SearchRecording[]
  agents: SearchAgent[]
  messages: SearchMessage[]
}

/**
 * Calls GET /search?q=&limit= and returns the typed search results.
 * Backend tenant-scopes, rate-limits, and short-circuits queries < 2 chars.
 */
export async function searchGlobal(q: string, limit = 5): Promise<SearchResults> {
  return api.get<SearchResults>(
    `/search?q=${encodeURIComponent(q)}&limit=${limit}`,
  )
}
